import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps, PremiumServiceType } from '__utils/type';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import { isProUser, getName, logOutUser, isAgentEuin } from '__utils/common-utils';
import { isBtoCFlow } from '../../__utils/common-utils';
import landingPageHeroImg from 'images/landing-page-hero-image.png';
import './index.css';
import HomeBanner from './home-banner';
import DiwaliGift from './diwali-gifts';
import Accordion from 'components/accordion';
import GreaterIcon from 'assets/icons/greater-than-icon';
import { COLOR } from 'constants/colors';
import BrowseFunds from './funds-by-category';
import { FAQs, premiumServices } from './home-constants';
import { useHistory } from 'react-router-dom';
import { Mixpanel } from '__utils/mixpanel';
import { getEventName } from '../../__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { BestSellingMintpacks, CalculatorSection, LearnMFBusinessComponent } from './home-helper';
import SingleViewContentPopup from './single-view-content';
import CreateLeadOnHome from './home-create-lead';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { isMintproApp } from '__utils/common-utils';
import MobileFooterLayout from 'components/old-footer-layout';
import Footer from 'components/footer';
import { MobileWebText } from 'views/common-styled-components';
import UserSelector from 'views/user/user.selector';
import LAMFBanner from './lamf-banner';
import LAMFThankYouPopup from './lamf-thank-you-popup'


const OuterCont = styled.div<CommonStyledComponentProps>`
     .alignCenter{
        align-items: center;
    }
    .mint-head {
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
        font-weight: ${(props: CommonStyledComponentProps) => props.isMobile ? '500' : '400'};
    }
    .mint-small-text{
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        color: ${COLOR.GREY};
        margin-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '8px' : '30px'};
        line-height: normal;
    }
    .custReport {
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '8px 16px' : '24px'};
        flex-direction: ${(props: CommonStyledComponentProps) => props.isMobile ? 'column' : 'row'};
        span{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'}
        }
    }
    .mint-grid{
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px 16px 20px' : '60px 0'};
    }
    .mint-box {
        flex-basis: ${(props: CommonStyledComponentProps) => props.isMobile ? '76%' : '91%'};
    }
    .generateInvest p {
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
    }
    .showAll p{
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
    }
`;

const Home: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const history = useHistory();
    const { countTotalAUM,isAgentNotAllowed } = propsToJS(useSelector(UserSelector));
    const [customerReportURL, setCustomerReportURL] = useState<any>();
    const [showLAMFPopup, setShowLAMFPopup] = useState<boolean>(true);
	const [showThankYouPopup, setShowThankYouPopup] = useState<any>(false);

    const openThankYouPopup = () => {
		if (showLAMFPopup) {
            setShowLAMFPopup(false);
        }
		setShowThankYouPopup(true);
	};

    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    useEffect(() => {
        SetLayoutProps({
            showGlobalFooter: isMobile ? true : false,
            showCopyrightInfoForDesktop: true,
            hideTopPaddingMobile: true
        })
        if(isProUser()) {
            getReportUrl();
        }
        Mixpanel.track(getEventName('webApp', 'loaded', 'home'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const goToPremiumService = (url: string, type: string) => {
        history.push(url);
        Mixpanel.track(getEventName('viewPremiumServices', 'clicked', 'home'), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isBtoCFlow: isBtoCFlow(),
            type: type
        });
    }

    //generate customer report URL
    const getReportUrl = () => {
        get(ENDPOINTS.GET_REPORTS_URL + `?agentCode=${getAgentCode()}`, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.responseData && response?.response?.responseData !== '') {
                    setCustomerReportURL(response?.response?.responseData)
                }
                else setCustomerReportURL('/transaction-error')

            }, (error: AjaxError) => {
                console.error(error);
            });

    };

    const generateCustReport = () => {
        Mixpanel.track(getEventName('generateCustReport', 'clicked', 'home'));
        if (isMintproApp()) {
            var featurePayload = {
                type: 'chromeTab',
                payload: {
                    url: customerReportURL
                },
            };

            // Trigger the download
            window.postMessage(JSON.stringify(featurePayload), '*');
            window.location.reload();
        }

    };

    return <>
        <OuterCont isMobile={isMobile}>
            {(getUserDetails() && isProUser() && !isMobile) && <div>
                <p className="greyTxt f16 exitFont">
                    You are logged into {getName()}'s account. <span className="greenTxt boldText cursorP" onClick={logOutUser}>Exit Account </span>
                </p>
            </div>}

            <Row align='bottom' gutter={isMobile ? 0 : 44}>
                <Col xs={0} md={15}>
                    {/* {isBtoCFlow() ? <img src={landingPageHeroImg} alt="landing-page-hero"
                        className="banner-newHome" />
                        : <iframe className="km-video" width="659" height="360px"
                            src="https://www.youtube.com/embed/DdOCQFrvjD8"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" >
                        </iframe>} */}
                        {<img src={landingPageHeroImg} alt="landing-page-hero"
                        className="banner-newHome" />}
                </Col>
                <Col xs={24} md={9}>
                {!isMobile && (
                    <>
                        {showLAMFPopup && <LAMFBanner openThankYouPopup={openThankYouPopup} />}
                        {showThankYouPopup && <LAMFThankYouPopup/>}
                        <HomeBanner />
                    </>
                )}
                </Col>
            </Row>

            {/* {isProUser() && countTotalAUM && countTotalAUM?.customerCount < 2 && countTotalAUM?.totalAUM == 0 && <CreateLeadOnHome />} */}

            <CalculatorSection />
            {isMobile && <HomeBanner />}
            {isMobile && showLAMFPopup && <LAMFBanner openThankYouPopup={openThankYouPopup} />}
            {isMobile && showThankYouPopup && <LAMFThankYouPopup/>}

            {/* <BestSellingMintpacks /> */}

            {/* Customer Investment Report  */}
            {(isProUser() && !( isAgentEuin())) && <div className="mb60 mt16">
                <div className={`mint-box custReport ${isMobile ? 'ft16' : 'ft24'}`}>
                    <div>
                        <p>Customer Investment Report <br /> </p>
                        <span>Generate investment reports in multiple formats for your customers.</span>
                        {isMobile && <span><br /><br />The reports are best viewed on Laptop/Desktop</span>}
                    </div>
                    <a href={customerReportURL} className="exploreAll" target="_blank" onClick={generateCustReport}>
                        <MobileWebText isMobile={isMobile} fonts={[14, 16]}>
                            <p>Generate Investment Report <GreaterIcon color={COLOR.GREEN} height='12' width='12'/></p>
                        </MobileWebText>
                    </a>
                </div>
            </div>}

            {/* {isMobile && isProUser() && <LearnMFBusinessComponent />} */}

            {!isMobile && <BrowseFunds />}
            {isMobile && <div className='mint-box accordion-bg'>
                <h3>Frequently Asked Questions</h3>
                <Accordion list={FAQs}></Accordion>
            </div>
            }
            {isProUser() &&  <SingleViewContentPopup />}

        </OuterCont >
        {isMobile &&
            <Footer>
                <MobileFooterLayout />
            </Footer>
        }
    </>

}
export default Home;